const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

let firebaseAuthPromise: Promise<import('firebase/auth').Auth> | null = null;

export const getFirebaseAuth = async (): Promise<import('firebase/auth').Auth> => {
  if (!firebaseAuthPromise) {
    firebaseAuthPromise = (async () => {
      if (!firebaseConfig.apiKey) {
        throw new Error(
          'Firebase configuration is missing. Check your VITE_FIREBASE_* environment variables.',
        );
      }

      const [{ getApp, getApps, initializeApp }, { getAuth }] = await Promise.all([
        import('firebase/app'),
        import('firebase/auth'),
      ]);

      const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
      return getAuth(app);
    })().catch((error) => {
      firebaseAuthPromise = null;
      throw error;
    });
  }

  return firebaseAuthPromise;
};
